import Vue from 'vue'
//Bars
import barTopApp from '@/components/bars/bar-app.vue'
import barBottomMobile from "@/components/bars/bar-bottom-mobile.vue"
// Drawers
import drawerAccount from "@/components/drawers/drawer-account.vue"
// Cards
import cardListItem from "@/components/cards/card-list-item.vue"
import cardInfoVertical from "@/components/cards/card-info-vertical.vue"
import cardInfoHorizontal from "@/components/cards/card-info-horizontal.vue"
import cardInfoHorizontalSlider from "@/components/cards/card-info-horizontal-slider.vue"
import cardList from "@/components/cards/card-list.vue"
import cardUser from "@/components/cards/card-user.vue"
// Notifiers
import errorSnackBar from "@/components/notifiers/error-snackbar.vue"
import notificationSnackBar from "@/components/notifiers/notification-snackbar.vue"
import confirmDialog from "@/components/notifiers/confirm-dialog.vue"

// Grid Layouts
import gridTwoColumn from "@/layouts/two-column.vue"
import gridSingleColumn from "@/layouts/single-column.vue"
import gridSingleColumnCenter from "@/layouts/single-column-center.vue"
import gridFullscreen from "@/layouts/fullscreen.vue"
// Icons
import iconLogo from "@/components/icons/icon-logo.vue"
import iconSvg from "@/components/icons/icon-svg.vue"
// Infinite scroller
import infiniteScrollerVertical from "@/components/infinite-scroller/infinite-scroll-vertical"
import infiniteScrollerHorizontal from "@/components/infinite-scroller/infinite-scroll-horizontal"
// Listings
import listPhotos from "@/components/list/list-photos.vue"
import listFooterNav from "@/components/list/list-footer-nav.vue"
// Sections
import sectionHeader from "@/components/section/section-header.vue"
// Sidebars
import sidebarLeft from "@/components/sidebars/sidebar-left.vue"
// Texts
import textDescription from "@/components/text/text-description.vue"
import textMetaCount from "@/components/text/text-meta-count.vue"
//Widgets
import widgetComments from "@/components/widgets/widget-comments.vue"
import widgetDiscoverPeople from "@/components/widgets/widget-discover-people.vue"
import widgetStories from "@/components/widgets/widget-stories.vue"
import widgetStoriesMobile from "@/components/widgets/widget-stories-mobile.vue"
import widgetSuggestion from "@/components/widgets/widget-suggestions.vue"
import widgetSuggestionMobile from "@/components/widgets/widget-suggestions-mobile.vue"
import widgetSearch from "@/components/widgets/widget-search.vue"
import widgetRate from "@/components/widgets/widget-rate.vue"
import widgetMediaUploader from "@/components/widgets/widget-mediauploader.vue"
import widgetRecentUploads from "@/components/widgets/widget-recent-uploads.vue"

// Mixins
import mixins from "@/mixins"
// Filters
import errorFilter from "@/filters/userError.filter"
import dateFilter from "@/filters/date.filter"
import toKFilter from "@/filters/toK.filter"
import roleFilter from "@/filters/role.filter"

/** 
 * Base Config store
 *---------------------
 */
class ConfigStore {
    /**
     * Creating custom data
     * -----------------
     */
    constructor(data = {}) {
        this.storeVM = new Vue({ data })
    }

    /**
     * Getting states
     * -----------------
     */
    get state() {
        return this.storeVM.$data
    }
}

/** 
 * Creating Base Config
 * ---------------------
 */
const BaseConfig = {
    Store: ConfigStore,

    install(Vue, options) {
        /** 
         * Add mixins 
         * Needed to include $baseConfig object for all components
         * ---------------------
         */
        Vue.mixin({
            beforeCreate() {
                this.$baseConfig = options.store
            },
            ...mixins
        })

        /**
         * Adding Filters
         * filters needed for the app
         * -----------------------
         */

        Vue.filter('userError', errorFilter)
        Vue.filter('dateFilter', dateFilter)
        Vue.filter('toK', toKFilter)
        Vue.filter('role', roleFilter)

        /** 
         * Adding Components
         * ---------------------
         */
        Vue.component('bar-app', barTopApp)
        Vue.component('bar-bottom-mobile', barBottomMobile)
        Vue.component('card-list', cardList)
        Vue.component('card-list-item', cardListItem)
        Vue.component('card-info-vertical', cardInfoVertical)
        Vue.component('card-info-horizontal', cardInfoHorizontal)
        Vue.component('card-info-horizontal-slider', cardInfoHorizontalSlider)
        Vue.component('card-user', cardUser)
        Vue.component('drawer-account', drawerAccount)
        Vue.component('error-snackbar', errorSnackBar)
        Vue.component('notification-snackbar', notificationSnackBar)
        Vue.component('confirm-dialog', confirmDialog)
        Vue.component('grid-two-column', gridTwoColumn)
        Vue.component('grid-single-column', gridSingleColumn)
        Vue.component('grid-single-column-center', gridSingleColumnCenter)
        Vue.component('grid-fullscreen', gridFullscreen)
        Vue.component('icon-logo', iconLogo)
        Vue.component('icon-svg', iconSvg)
        Vue.component('infinite-scroller-vertical', infiniteScrollerVertical)
        Vue.component('infinite-scroller-horizontal', infiniteScrollerHorizontal)
        Vue.component('list-photos', listPhotos)
        Vue.component('list-footer-nav', listFooterNav)
        Vue.component('section-header', sectionHeader)
        Vue.component('sidebar-left', sidebarLeft)
        Vue.component('text-description', textDescription)
        Vue.component('text-meta-count', textMetaCount)
        Vue.component('widget-comments', widgetComments)
        Vue.component('widget-discover-people', widgetDiscoverPeople)
        Vue.component('widget-stories', widgetStories)
        Vue.component('widget-stories-mobile', widgetStoriesMobile)
        Vue.component('widget-suggestions', widgetSuggestion)
        Vue.component('widget-suggestions-mobile', widgetSuggestionMobile)
        Vue.component('widget-search', widgetSearch)
        Vue.component('widget-rate', widgetRate)
        Vue.component('widget-media-uploader', widgetMediaUploader)
        Vue.component('widget-recent-uploads', widgetRecentUploads)
    }
}

/** 
 * App Messages
 * ---------------------
 */

export const ALERT_EMAIL_IN_USE = "Email already in use"
export const ALERT_USERNAME_IN_USE = "Username taken"
export const ALERT_WRONG_CREDENTIALS = "Sorry!, no user with this credential"

/**
 * Date Format
 * ---------------------
 */
export const DATE_FORMAT = {
    month: 'short',
    day: '2-digit',
    year: 'numeric'
}

/*
 * Plugins scrollmagic gsap connection
 */
import ScrollMagic from "scrollmagic"
import { gsap } from "gsap"
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap"
ScrollMagicPluginGsap(ScrollMagic, gsap)

export default BaseConfig